import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { StorageItemService } from "app/shared/services/storageItem.service";

@Component({
    selector: 'app-file-preview-dialog',
    templateUrl: './file-preview-dialog.component.html',
    styleUrls: []
  })

export class FilePreviewDialogComponent implements OnInit {
    public src: string = '' ;
    dataType: string;
    public isLoading = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private storageService: StorageItemService,
        private _snackBar: MatSnackBar) {}

    ngOnInit(): void {
        this.src = this.data.version;
        this.isLoading = false;
    }

    clickDownloadFile() {
        this.storageService.downloadFolderDoc(this.data.file).subscribe((response: any) => {
          const byteCharacters = atob(response);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
    
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.style.display = 'none';
          a.href = url;
          a.download = this.data.fileName;
          a.click();
          window.URL.revokeObjectURL(url);
        }, error => {
          this._snackBar.open('Échec du téléchargement', null, {
            duration: 2000,
            panelClass: 'warn-snackbar',
          });
    
        });
    }

}